import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  clearSearchModelElementsReducer,
  getModelElementsReducer,
  setModelElementSearchReducer,
  setMultipleModelElementSearchReducer,
  setModelElementSearchByIdsReducer,
  setLoadingSearchModelElementsReducer,
} from '@/redux/modelElements/modelElements.reducers';
import { MODEL_ELEMENTS_INITIAL_STATE_MOCK } from '@/redux/modelElements/modelElements.mock';
import { ModelElement } from '@/types/models';
import { ONE } from '@/constants/common';

export const modelElements = createSlice({
  name: 'modelElements',
  initialState: MODEL_ELEMENTS_INITIAL_STATE_MOCK,
  reducers: {
    setModelElementSearch: setModelElementSearchReducer,
    setMultipleModelElementSearch: setMultipleModelElementSearchReducer,
    clearSearchModelElements: clearSearchModelElementsReducer,
    setModelElementSearchByIds: setModelElementSearchByIdsReducer,
    setLoadingSearchModelElements: setLoadingSearchModelElementsReducer,
    modelElementUpdate: (
      state,
      action: PayloadAction<{ modelId: number; element: ModelElement }>,
    ) => {
      const { modelId, element } = action.payload;
      const modelData = state.data[modelId];
      if (modelData?.data) {
        const index = modelData.data.findIndex(e => e.id === element.id);
        if (index !== -ONE) {
          modelData.data[index] = element;
        }
      }
    },
    modelElementDelete: (state, action: PayloadAction<{ modelId: number; elementId: number }>) => {
      const { modelId, elementId } = action.payload;
      const modelData = state.data[modelId];
      if (modelData?.data) {
        modelData.data = modelData.data.filter(e => e.id !== elementId);
      }
    },
  },
  extraReducers: builder => {
    getModelElementsReducer(builder);
  },
});

export const {
  setModelElementSearch,
  setMultipleModelElementSearch,
  clearSearchModelElements,
  setModelElementSearchByIds,
  setLoadingSearchModelElements,
  modelElementUpdate,
  modelElementDelete,
} = modelElements.actions;

export default modelElements.reducer;
